import Home from './components/home/Home.vue';
import PageNotFound from './components/PageNotFound.vue';
import ChargingFeedback from './components/home/ChargingFeedback.vue';

export const routes = [
	{ path: '/cobranca', name: 'no-charging', component: PageNotFound },
	{ path: '/cobranca/feedback', name: 'charging-feedback', component: ChargingFeedback, props: true },
	{ path: '/cobranca/:id', name: 'charging', component: Home },
	{ path: '/', name: 'page-not-found', component: PageNotFound },
	{ path: '*', redirect: '/' }
];



// WEBPACK FOOTER //
// ./src/routes.js